export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const COMPANY_ID = 'companyId';
export const COMPANY_IMAGE = 'companyImage';
export const COMPANY_NAME = 'companyName';
export const COMPANY_DISTANCE_MAX = 'companyDistanceMax';
export const USER_PATH = 'userPath';
